import React from 'react';

/**
 * Stakes — three pain-point cards. Eyebrow auto-numbered when rendered inside
 * a `.numbered-sections` ancestor.
 */
export default function Stakes() {
  const items = [
    {
      n: '01',
      title: 'Ihre Zeit ist zu wertvoll',
      detail: 'Ob während der Arbeit oder in der Freizeit. Ihre Immobilie ist in Eigenverwaltung oder mit dem falschen Partner nie wirklich passiv. Es passiert ständig etwas und immer zum schlechtesten Zeitpunkt. Immobilien interessieren sich in Problemfällen nicht für Arbeitszeiten, Wochenenden oder Urlaub.',
      tag: 'Was ist eigentlich Ihre Stunde Arbeit wert? Und Ihre Freizeit?',
    },
    {
      n: '02',
      title: 'Ihr Geld kann mehr',
      detail: 'Jeder Euro nicht erhöhter Monatsmiete ist beim späteren Verkauf im Schnitt 20,00 € und mehr wert. Nicht optimierte und falsche Abrechnungen bedeuten, dass Sie für Ihre Mieter zahlen. Leere Wohnungen bedeuten für Sie als Eigentümer ein Minus.',
      tag: '10.000 € Kaltmiete pro Jahr mehr = >200.000 € Vermögen!',
    },
    {
      n: '03',
      title: 'Ihre Nerven sind unbezahlbar',
      detail: 'Sie sind nicht der Sachbearbeiter Ihres Vermögens. Als Unternehmer, Führungsperson und Elternteil ist Ihre Aufmerksamkeit woanders viel wertvoller.',
      tag: 'Sachbearbeiter Ihres Vermögens & Stunden, die Sie verlieren',
    },
  ];

  return (
    <section style={{ padding: '120px 0', background: 'var(--cream-deep)' }}>
      <div className="shell">
        <div
          className="reveal"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 0,
            marginBottom: 72,
            alignItems: 'start',
          }}
        >
          <div>
            <div className="section-label numbered" style={{ marginBottom: 24 }}>
              <span>Die Herausforderungen</span>
            </div>
            <h2 className="h-section" style={{ fontSize: 'clamp(28px, 3vw, 40px)', lineHeight: 1.15 }}>
              Kennen Sie das?
            </h2>
          </div>
          <div style={{ paddingTop: 10 }}>
            <p
              style={{
                fontFamily: 'var(--serif)',
                fontStyle: 'italic',
                fontSize: 18,
                lineHeight: 1.65,
                color: 'var(--charcoal-muted)',
              }}
            >
              Donnerstagmorgen, beste Arbeitszeit. Der Mieter ruft schon zum dritten Mal an. Oder schlimmer: Kindergeburtstag, Samstagnachmittag. Vier verpasste Anrufe und zwei Nachrichten auf der Mailbox. Ihr Mieter steht knietief im Wasser. Und wann wurden eigentlich die Mieten das letzte Mal erhöht? Moment, der Mieter aus der Wohnung im 1. OG rechts hat seit drei Monaten nicht gezahlt! Die Abrechnungen sind auch wieder fällig. Was ist das Objekt eigentlich inzwischen wert?
            </p>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 20 }}>
          {items.map((it, i) => (
            <article
              key={i}
              className="reveal"
              style={{
                background: 'var(--cream)',
                border: '1px solid var(--cream-line)',
                padding: '32px 26px 28px',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  position: 'absolute',
                  top: -1,
                  left: -1,
                  width: 40,
                  height: 2,
                  background: 'var(--bordeaux)',
                }}
              />

              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
                <span style={{ width: 8, height: 8, background: 'var(--bordeaux)', display: 'inline-block' }} />
                <span
                  style={{
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                    fontSize: 12,
                    letterSpacing: '0.1em',
                    color: 'var(--charcoal-muted)',
                  }}
                >
                  {it.n}
                </span>
              </div>

              <h3
                lang="de"
                className="h-pillar"
                style={{
                  fontSize: 19,
                  lineHeight: 1.3,
                  marginBottom: 20,
                  minHeight: '5.2em',
                  hyphens: 'auto',
                  overflowWrap: 'break-word',
                }}
              >
                {it.title}
              </h3>

              <p
                style={{
                  fontSize: 14,
                  color: 'var(--charcoal-muted)',
                  lineHeight: 1.6,
                  margin: 0,
                  paddingTop: 18,
                  borderTop: '1px solid var(--cream-line)',
                }}
              >
                {it.detail}
              </p>

              <div
                style={{
                  marginTop: 'auto',
                  paddingTop: 18,
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                  fontSize: 11,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  color: 'var(--bordeaux)',
                }}
              >
                {it.tag}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
